import * as API from '../../api'
import * as ActionTypes from "../action-types";


export const set_selected_live_camera_by_vid_request = (vid, mdvrid, isLive = false, attachments) => dispatch => {
    // console.log(attachments)
    dispatch(set_selected_live_camera_by_vid_success(vid, mdvrid, isLive, attachments))
} 

const set_selected_live_camera_by_vid_success = (vid, mdvrid, isLive, attachments) => {
    return {
        type: ActionTypes.SET_SELECTED_LIVE_CAMERA_BY_VID,
        vid, mdvrid, isLive, attachments
    }
}

export const unset_selected_live_camera_by_vid_request = () => dispatch => {
    dispatch(unset_selected_live_camera_by_vid_success())
} 

const unset_selected_live_camera_by_vid_success = () => {
    return {
        type: ActionTypes.UNSET_SELECTED_LIVE_CAMERA_BY_VID,
    }
}

export const get_user_info_cms_request = (cb = () => {}) => dispatch => {
    
    API
    .getUserInfoCMS()
    .then(info => {
        const { user, status } = info

        if(status === 200) {
            dispatch(get_user_info_cms_success(user))
            cb(user)
        }
    })
}

const get_user_info_cms_success = (user) => {
    return {
        type: ActionTypes.GET_USER_INFO_CMS,
        user
    }
}